import React, { useState, useEffect, useRef, useContext } from "react";
import { PageSettings } from "../../config/page-settings";
import ButtonGroup from "components/ButtonGroup";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getPackageCurrencyList, getPackageListByCurrencyIdAndIsMonthly } from "../../api/priceApi";

import { razorPayment } from "../../api/razorpayapi";
import {
  UserPackageCreate,
  IsCheckUserPackageUpgradeOrNot,
  getUsrActivePackageDetail,
  GetFullMobileUserDetailByEmailAddress
} from "../../api/packageApi";
import {
  CheckUserIslock
} from "../../api/apiuser.js";

// import { usePaymentInputs, PaymentInputsWrapper } from "react-payment-inputs";
// import images from "react-payment-inputs/images";

import {
  withRouter,
  useHistory,
  Redirect,
  useLocation,
} from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import swal from "sweetalert";
import Config from "../../Config";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";

const loadRazorpayScript = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve();
    script.onerror = () => reject('Razorpay script failed to load');
    document.body.appendChild(script);
  });
};

const Pricingpage = () => {

  const { loginWithRedirect } = useAuth0();
  let history = useHistory();
  const [rolename, setroleName] = useState(
    localStorage.getItem("loginRoleName")
  );
  const context = useContext(PageSettings);
  const [first, setFirst] = useState("");
  const [second, setsecond] = useState("");
  const [third, setThird] = useState("");
  const [itemIndex, setItemIndex] = useState(0);
  const [currency, setcurrency] = useState("");
  const [currencyList, setcurrencyList] = useState([]);
  const [CurrencyAndPackageDetails, setCurrencyAndPackageDetails] = useState([]);
  // const [yearlyitem, setyearlyitem] = useState([
  //   { lable: "Monthly", value: 1, select: true },
  //   { lable: "Yearly", value: 2, select: false },
  // ]);
  let loginid = localStorage.getItem("loginUserID");
  const [isMonthly, setisMonthly] = useState(true);
  const [PackageName, setPackageName] = useState("");
  const [SegmentEditisOpen, setSegmentEditisOpen] = useState(false);
  const [PaymentDetailsisOpen, setPaymentDetailsisOpen] =
    useState(false);
  const [autorenewal, setautorenewal] = useState(true);
  const [totalPrice, settotalPrice] = React.useState("");
  const [loading, setisLoading] = React.useState(false);
  const [LoadingCurrency, setisLoadingCurrency] = React.useState(false);
  const [LoadingPackageList, setisLoadingPackageList] = React.useState(false);

  const [isPaymentshow, setisPaymentshow] = useState(false);
  const [packageID, setpackageID] = useState('');
  const [packagePriceID, setpackagePriceID] = useState('')

  const [selectitemIndex, setselectitemIndex] = useState(["2"]);
  const [UserPackageInfo, setUserPackageInfo] = useState(null);

  const [MobileUserEmail, setMobileUserEmail] = useState("");
  const [MobileUserEmailError, setMobileUserEmailError] = useState("");
  const [MobileUserInfo, setMobileUserInfo] = useState(null);
  const [isWeb, setisWeb] = useState(true);
  const [IsuserDetailsisOpen, setIsuserDetailsisOpen] =
    useState(false);

  const [isMobileUserPaymentshow, setMobileUserisPaymentshow] = useState(false);
  const [MobileUserPaymentDetailsisOpen, setMobileUserPaymentDetailsisOpen] =
    useState(false);

  const [isstripePay, setisstripePay] = useState('Stripepay');
  const [isRazorAvailable, setIsRazorAvailable] = useState(false);

  // const {
  //   meta,
  //   wrapperProps,
  //   getCardNumberProps,
  //   getExpiryDateProps,
  //   getCVCProps,
  //   getCardImageProps,
  // } = usePaymentInputs();
  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetPageContentFullWidth(true);
    return () => {
      context.handleSetPageSidebar(true);
      context.handleSetPageHeader(true);
      context.handleSetPageContentFullWidth(false);
    };
  }, []);
  useEffect(() => {
    localStorage.removeItem('Pricingpage');
    GetPackageCurrencyList();
    if (loginid) {
      GetUsrActivePackageDetail();
    }
  }, []);
  useEffect(() => {
    if (currency) {
      GetPackageListByCurrencyIdAndIsMonthly(currency, isMonthly)
    }
    else {
      setCurrencyAndPackageDetails([]);
    }

  }, [currency, isMonthly]);


  useEffect(() => {
    if (UserPackageInfo?.isActive) {
      const currencylist = [...currencyList]
      let ActivePackagecurrencyID = UserPackageInfo?.currencyID;
      if (ActivePackagecurrencyID && currencylist.length > 0) {
        const Activecurrency = currencylist.filter(x => x.value === ActivePackagecurrencyID);
        if (Activecurrency) {
          setcurrencyList(Activecurrency);
          // setcurrency(Activecurrency[0]?.value)
        }
        else {
          setcurrencyList([]);
          setcurrency("");
        }
      }
    }
  }, [UserPackageInfo]);

  const toggleUserDetails = () => {
    setIsuserDetailsisOpen(false)
  };

  const styles = {
    display: first,
  };
  const styles2 = {
    display: second,
  };
  const styles3 = {
    display: third,
  };


  const onselectitemIndex = (index) => {
    let oldindex = [...selectitemIndex];
    oldindex[0] = index.toString();
    setselectitemIndex(oldindex);
  }

  const onPressPrevious = () => {
    let oldindex = [...selectitemIndex];
    let oldindexValue = oldindex[0];
    let oldindexValuetemp = parseInt(oldindexValue);
    if (oldindexValuetemp === 0) {
      oldindex[0] = "0";
    }
    else {
      let selectbvalu = (oldindexValuetemp - 1).toString();
      oldindex[0] = selectbvalu;
    }
    setselectitemIndex(oldindex);
  }

  const GetPackageCurrencyList = async () => {
    try {
      setisLoadingCurrency(true);
      let data = await getPackageCurrencyList();
      console.log("getPackageCurrencyListData===>", data)
      setcurrencyList(data);
      setisLoadingCurrency(false);
      if (loginid === "" || loginid === undefined || loginid === null) {
        setcurrency(data[0]?.value);
      }
    } catch (error) {
      setisLoadingCurrency(false);
      console.log("getPackageCurrencyListE5rror==>", error)
    }
  };

  const GetUsrActivePackageDetail = async () => {
    setUserPackageInfo(null);
    if (rolename === "Admin") {
      try {
        let data = await getUsrActivePackageDetail();
        if (data != null && data?._id !== null && data?._id !== "" && data?._id !== undefined) {
          console.log("GetUserPackage===>", data)
          setUserPackageInfo(data)
        }

      } catch (error) {
        console.log("getPackageCurrencyListE5rror==>", error)
      }
    }

  };
  const GetPackageListByCurrencyIdAndIsMonthly = async (currencyID, ismonthely) => {

    try {
      if (currencyID) {
        setisLoadingPackageList(true);
        let currencyinfo = currencyList.find(x => x.value == currencyID);
        let data = await getPackageListByCurrencyIdAndIsMonthly(currencyID, ismonthely);
        console.log("getPackageListByCurrencyIdAndIsMonthlyData===>", data);
        const tempdata = [];

        const addFreedata = {
          "_id": "",
          "subAccountCount": "0",
          "staticQrCodeCount": "-1",
          "priceId": "",
          "price": "0.00",
          "packageName": "Lite Tag (Free)",
          "noOfChatUser": "15",
          "monthlyScanCount": 150,
          "isYourBranding": false,
          "isWhiteLabelling": false,
          "isWeb": true,
          "isSSLCertificate": false,
          "isQrCodeSaveInWallet": false,
          "isQrCodeCategoryManaged": false,
          "isMonthly": true,
          "isIndividualSupport": false,
          "isIndividualPhoneSupport": false,
          "isExportQrCode": false,
          "isEmailSupport": false,
          "isChatEnabled": false,
          "isAdvanceQrCodeSearch": true,
          "dynamicQrCodeCount": "1",
          "dataStorageCount": "150000000",
          "isAdvanceQrCodeSearch": true,
          "currencyOtherName": currencyinfo?.otherName,
          "currencyName": currencyinfo?.otherName,
          "currencyID": currencyID,
          "categoryId": "",
          "bulkQrCodeCount": "0",
          "articalSavingCount": "1",
          "apDynamicQrCodeCount": "1",
          "isCustomised": false,
          "IsDefault": true

        }
        tempdata.push(addFreedata);
        const adddata = {
          "_id": "",
          "subAccountCount": "-1",
          "staticQrCodeCount": "-1",
          "priceId": "",
          "price": "",
          "packageName": "Customised",
          "noOfChatUser": "-1",
          "monthlyScanCount": true,
          "isYourBranding": true,
          "isWhiteLabelling": true,
          "isWeb": true,
          "isSSLCertificate": true,
          "isQrCodeSaveInWallet": true,
          "isQrCodeCategoryManaged": true,
          "isMonthly": true,
          "isIndividualSupport": true,
          "isIndividualPhoneSupport": true,
          "isExportQrCode": true,
          "isEmailSupport": true,
          "isChatEnabled": true,
          "isAdvanceQrCodeSearch": true,
          "dynamicQrCodeCount": "-1",
          "dataStorageCount": "-1",
          "isAdvanceQrCodeSearch": true,
          "currencyOtherName": "",
          "currencyName": "",
          "currencyID": "",
          "categoryId": "",
          "bulkQrCodeCount": "-1",
          "articalSavingCount": "-1",
          "apDynamicQrCodeCount": "-1",
          "isCustomised": true,

        }
        data.map((item) => {
          tempdata.push(item)
        });
        tempdata.push(adddata);
        setCurrencyAndPackageDetails(tempdata);
        setisLoadingPackageList(false);
      }
      else {
        setCurrencyAndPackageDetails([]);
        setisLoadingPackageList(false);
      }
    } catch (error) {
      setCurrencyAndPackageDetails([]);
      setisLoadingPackageList(false);
      console.log("getPackageListByCurrencyIdAndIsMonthlyE5rror==>", error)
    }
  }
  const bytesToSizeRemaining = (Packeagebytes) => {
    if (
      Packeagebytes !== null &&
      Packeagebytes !== undefined &&
      Packeagebytes !== ""
    ) {
      let bytes = parseFloat(Packeagebytes);
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return 0;
      // var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
      if (i == 0) return bytes + " " + sizes[i];
      return (bytes / Math.pow(1000, i)).toFixed(0) + " " + sizes[i];
    } else {
      return "N/A";
    }
  };
  const togglePaymentDetails = () => {
    if (rolename === "Admin") {
      setisPaymentshow(false)
      setPaymentDetailsisOpen(!PaymentDetailsisOpen);
      setisstripePay('Stripepay');
    }
    else {
      setPaymentDetailsisOpen(false);
      if (PaymentDetailsisOpen) {
        swal("Only admin user support");
      }
    }
  };
  const togglePaymentDetailsMobileUser = () => {
    if (rolename === "MobileUser") {
      setisPaymentshow(false)
      setPaymentDetailsisOpen(!PaymentDetailsisOpen);
    }
    else {
      setPaymentDetailsisOpen(false);
      if (PaymentDetailsisOpen) {
        swal("Only admin user support");
      }
    }
  };
  const Proceedpackage = async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (packageID && checkLogin && packagePriceID) {
      let ischeckupdateornot = await IsCheckUserPackageUpgradeOrNot(packageID, checkLogin, packagePriceID, isstripePay);
      if (ischeckupdateornot === true) {
        setisPaymentshow(true);
      }
      else {
        swal("Please adjust your current package with your previous one. Click this link to review and make the necessary adjustments.");
      }
    }
  };



  const onSubmit = async () => {

    let checkLogin = localStorage.getItem("loginUserID");
    let retval = {
      "userID": checkLogin,
      "packagePriceID": packagePriceID,
      "isautorenewal": autorenewal,
      "packageID": packageID,
    }
    fetch(Config.apiUrl +
      "create-checkout-session/Create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(retval),
      },

    ).then((response) => {
      if (response?.status === 401) {
      }
      if (response.ok) {
        return response.json();
      }
      throw new Error("Something went wrong");
    })
      .then((responseJson) => {
        if (responseJson?.responseUrl !== null && responseJson?.responseUrl !== "" && responseJson?.responseUrl !== undefined && responseJson?.responseType !== 'Error') {
          window.location.replace(responseJson?.responseUrl)
        }
        else {
          swal(responseJson.message);
        }
      })
      .catch((error) => {
        swal("Error", + error);
      });
  };

  const handlePaymentSuccess = (response) => {
    console.log("Payment response:", response);
    const razorpay_payment_id = response.razorpay_payment_id;
    const razorpay_order_id = response.razorpay_subscription_id;
    const razorpay_signature = response.razorpay_signature;
    if (razorpay_payment_id) {
      togglePaymentDetails();
      swal("Your package has been successfully updated 30 minutes ago.");
    }
  };
  const onSubmitRazorpay = async () => {
    try {
      let checkLogin = localStorage.getItem("loginUserID");
      let retvalbody = {
        "userCompanyID": checkLogin,
        "systemPackagePriceUniqueGuid": packagePriceID,
        "isautorenewal": autorenewal,
        "packageId": packageID,
        "createdBy": checkLogin,
      }
      const res = await razorPayment(JSON.stringify(retvalbody));
      if (res?._id && res?.subscriptionId) {
        await loadRazorpayScript();
        const options = {
          key: Config.razorpaypublishablekey,
          subscription_id: res?.subscriptionId,
          name: "Your Company Name",
          description: "Subscription Payment",
          handler: function (response) {
            handlePaymentSuccess(response)
          },
          theme: {
            color: "#3399cc",
          },
        };
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      }
      else {
        swal("Error", + res);
      }
    } catch (err) {
      swal("Error!", err?.message, "error");
    }
  }


  const navbarRef = useRef(null);
  let prevScrollpos = window.pageYOffset;

  useEffect(() => {
    window.onscroll = () => {
      const currentScrollPos = window.pageYOffset;

      if (prevScrollpos > currentScrollPos) {
        navbarRef.current.style.top = "0";
      } else {
        navbarRef.current.style.top = "-90px";
      }

      prevScrollpos = currentScrollPos;
    }

    return () => {
      window.onscroll = null;
    }
  }, []);
  return (
    <>
      <div className="wordpresspage-body" style={{ backgroundColor: 'white' }} >
        {/* header */}
        <LoaderSpinner isrefresh={loading || LoadingCurrency || LoadingPackageList} />
        <nav className="navbar navbar-expand-lg navbar-light  wordPress-website sticky" id="navbar" ref={navbarRef} >
          <a className="navbar-brand col-lg-3  col-md-7 col-sm-7 col-xs-7 text-center" href="https://qrcode-stt.com/" >
            <img
              src="../assets/img/sttwordpressweb/stt-logo-2.png"
              style={{ maxWidth: " 35%" }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse col-lg-6 col-md-6"
            id="navbarSupportedContent"
          >

            <ul className="navbar-nav">


              <li
                onMouseEnter={() => setFirst("block")}
                onMouseLeave={() => setFirst("none")}
                className="nav-item dropdown"
              >
                <a
                  className="nav-link dropdown-toggle"
                  // href="javascript:void(0);"
                  href="#" onClick={(e) => { e.preventDefault(); }}
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Products
                  <span className="sub-arrow">
                    <svg
                      className="e-font-icon-svg e-fas-caret-down"
                      viewBox="0 0 320 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path>
                    </svg>
                  </span>
                </a>
                <div
                  className="dropdown-menu"
                  style={styles}
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/product-qr-code-generator/"
                  >
                    Product QR Code
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/bulk-qr-code/"
                  >
                    Bulk QR Code
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/personal-qr-code-generator/"
                  >
                    Personal QR Code
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/mobile-app-page/"
                  >
                    STT Smart App
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/deep-scanning-analytics/">
                    Deep Scanning Analytics
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/end-consumer-communication/"
                  >
                    End consumer communication
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/why-and-how-does-it-work/"
                  >
                    Why STT
                  </a>
                </div>
              </li>
              <li
                onMouseEnter={() => setsecond("block")}
                onMouseLeave={() => setsecond("none")}
                className="nav-item dropdown"
              >
                <a
                  className="nav-link dropdown-toggle"
                  //href="javascript:void(0);"
                  href="#" onClick={(e) => { e.preventDefault(); }}
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Industries
                  <span className="sub-arrow">
                    <svg
                      className="e-font-icon-svg e-fas-caret-down"
                      viewBox="0 0 320 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path>
                    </svg>
                  </span>
                </a>
                <div
                  className="dropdown-menu"
                  style={styles2}
                  aria-labelledby="navbarDropdown"
                >
                  <a className="dropdown-item" href="https://qrcode-stt.com/engineering-and-mechanical-industry/">
                    Engineering and mechanical industry
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/qr-codes-for-consumer-products/">
                    Consumer products
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/real-estate/">
                    Real estate
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/beauty-and-personal-care/">
                    Beauty and personal care
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/beauty-and-personal-care/">
                    Textiles
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/travel-and-tourism/;">
                    Travel and tourism
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/foot-wear/">
                    Foot wear
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/baby-products/">
                    Baby products
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/food-industry/">
                    Food industry
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/high-performing-materials/">
                    High performing materials
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/all-pages/">
                    Explore all…
                  </a>
                </div>
              </li>
              <li
                onMouseEnter={() => setThird("block")}
                onMouseLeave={() => setThird("none")}
                className="nav-item dropdown"
              >
                <a
                  className="nav-link dropdown-toggle"
                  href="https://qrcode-stt.com/solution/"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Solution
                  <span className="sub-arrow">
                    <svg
                      className="e-font-icon-svg e-fas-caret-down"
                      viewBox="0 0 320 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path>
                    </svg>
                  </span>
                </a>
                <div
                  className="dropdown-menu"
                  style={styles3}
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/solution/"
                  >
                    Smart Industrial solutions
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/optimizing-marketing-campaigns/"
                  >
                    Consumer products
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/sustainability/"
                  >
                    Sustainability
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/digital-marketing/"
                  >
                    Digital marketing future
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://qrcode-stt.com/track-your-entire-production/"
                  >
                    Track your entire production
                  </a>
                  <a className="dropdown-item" href="https://qrcode-stt.com/digitalizing-your-physical-stuff/">
                    Digitalizing your physical stuff
                  </a>
                </div>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://app.qrcode-stt.com/Pricingpage">
                  Pricing
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://qrcode-stt.com/demo/">
                  Demo
                </a>
              </li>
            </ul>
          </div>
          <div className=" col-lg-3  col-md-4 col-sm-12 col-xs-12">
            <div className="row  row-nav">
              <a href="https://qrcode-stt.com/free-trial/" className="btn btn-warning startfreetrial-btn">
                Start free trial
              </a>
              {
                (loginid === null || loginid === "" || loginid === undefined) ?
                  <a
                    //  href="javascript:void(0);"
                    href="#"
                    className="text-button"
                    onClick={(e) => {
                      e.preventDefault();
                      localStorage.setItem("Pricingpage", "true");
                      localStorage.setItem("CurrencyID", "");
                      localStorage.setItem("ProductsID", "");
                      localStorage.setItem("IsMonthly", "");
                      loginWithRedirect()
                    }}>
                    Log in
                  </a>
                  : <a href="/Logout" className="text-button">
                    Log Out
                  </a>
              }
              {
                UserPackageInfo && (
                  (UserPackageInfo?.isActive === false) ?
                    <a href="/Home" className="text-button nav-link dashboard">
                      My Dashboard
                    </a>
                    : <></>
                )
              }
            </div>
          </div>
        </nav>

        {/* header */}

        {/* price */}

        {/* price */}
        <div className="padding-100price">

          {/* <div className="price-heading-subtitle">
            <h2 className="price-heading-title">Pricing and plans</h2>
          </div>
          <h2 className="innersuntitle-heading mb-5">Choose your suitable plan and currency below</h2> */}
          {
            UserPackageInfo && (
              (UserPackageInfo?.isActive === false) ?
                <> <div style={{ display: 'flex', justifyContent: 'center' }}><div className="innersuntitle-heading warning"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Your {UserPackageInfo?.systemPackageName} package has ended. Choose a plan and continue where you left off. </div> </div></>
                : <></>

            )
          }


          <div className="container-fluid">
            <div className="row mt-5 align-items-center">
              <div className="offset-1 col-lg-2 col-md-12 mt-2 d-flex justify-content-center selectPrice-main">
                <select
                  onChange={(e) => {
                    setcurrency(e.target.value);
                    onselectitemIndex(2);
                    console.log("e.target.value", e.target.value);
                  }}
                  value={currency}
                  className="form-control selectPrice mr-2"
                >
                  <option
                    value={""}
                    selected
                  //selected={currency === ""}
                  >
                    {"--- select currency ---"}
                  </option>
                  {currencyList?.length > 0 ?
                    currencyList?.map((item, i) => (
                      <option value={item?.value}> {`${item?.otherName} ${item?.label}`} </option>
                    ))
                    : <></>}
                </select>
              </div>
              <div className=" col-lg-6  col-md-12 d-flex flex-column align-items-center justify-content-center">
                <div className="price-heading-subtitle">
                  <h2 className="price-heading-title">Pricing & Plans</h2>
                </div>
                <h2 className="innersuntitle-heading mb-5">Choose your suitable plan and
                  currency below</h2>
              </div>
              <div className=" col-lg-3 col-md-12 mt-2 d-flex justify-content-center">
                <div className="btngroup-container mt-3 ">
                  <button
                    className={
                      "customButton" + (isMonthly === true ? " active" : "")
                    }
                    onClick={() => {
                      onselectitemIndex(2);
                      setisMonthly(true);
                    }}
                  >
                    Monthly
                  </button>
                  <button
                    className={
                      "customButton" + (isMonthly === false ? " active" : "")
                    }
                    onClick={() => {
                      onselectitemIndex(2);
                      setisMonthly(false);
                    }}
                  >
                    Yearly
                  </button>
                </div>
                {/* <div className="btngroup-container mt-3 ml-3">
                  <button
                    className={
                      "customButton" + (isWeb === true ? " active" : "")
                    }
                    onClick={() => {
                      onselectitemIndex(0);
                      setisWeb(true);
                    }}
                  >
                    Web
                  </button>
                  <button
                    className={
                      "customButton" + (isWeb === false ? " active" : "")
                    }
                    onClick={() => {
                      onselectitemIndex(0);
                      setisWeb(false);
                    }}
                  >
                    Mobile
                  </button>
                </div> */}
              </div>

            </div>
          </div>

          <div className="container-fluid" style={{ position: 'relative' }}>

            <div className="row">

              <div className="col-md-12">
                <div className="wrapper-plans">

                  {CurrencyAndPackageDetails?.length > 0 ?
                    CurrencyAndPackageDetails?.map((item, i) => (
                      (item?.isCustomised === true) ?
                        <div
                          className={"col-plans p-0  " +
                            (selectitemIndex[0] === i.toString() ? "active" : "") + (' ') +
                            (selectitemIndex[0] === (1 + i).toString() ? "zindex99" : "") + (' ') +
                            (selectitemIndex[0] === (i - 1).toString() ? "zindex99" : "") + (' ') +
                            (selectitemIndex[0] === (2 + i).toString() ? "zindex9" : "") + (' ') +
                            (selectitemIndex[0] === (i - 2).toString() ? "zindex9" : "") + (' ') +
                            (selectitemIndex[0] === (3 + i).toString() ? "zindex1" : "") + (' ') +
                            (selectitemIndex[0] === (i - 3).toString() ? "zindex1" : "")
                          }
                          onClick={() => {
                            onselectitemIndex(i);
                          }}
                        >
                          <div className="rounded card-height">
                            <div className=" ">
                              <p className="mb-0 p-1 header-card d-block mainText text-center">Customised</p>
                            </div>
                            {/* {
                              isMonthly == true ? 
                               <h2 className="priceLine text-center"><span>/month</span> </h2> 
                               :
                               <h2 className="priceLine text-center"><span>/annum</span> </h2>
                            } */}

                            <div className="card-body p-0 pt-0">
                              <div className="text-center pb-1">
                                {/* <p className="text-center">Anual plan saves 10%</p> */}
                              </div>
                              <div className="text-center mb-4">
                                <a href="https://qrcode-stt.com/contact-us" target="_blank">
                                  <button
                                    type="button"
                                    className="theme-green-bt lastBtn"
                                  >
                                    Contact us
                                  </button>
                                </a>
                              </div>
                              <div className="rounded">
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      {" "}
                                      <b className="highlight">Tier based</b> &nbsp; Life Tag QR Codes{" "}

                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      {" "}
                                      <b className="highlight">Tier based</b> &nbsp; Data storage limit

                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b> Unlimited </b> &nbsp;Dynamic QR Codes
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b> Unlimited </b> &nbsp; Static QR Codes
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b> Unlimited </b> &nbsp; Bulk QR Codes
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b>Unlimited</b> &nbsp;Monthly scans
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b className="highlight">Tier based</b>&nbsp; Users and team accounts

                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b>Unlimited</b>&nbsp; Memorial Messages{" "}
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b></b>&nbsp; Premium Support {" "}
                                    </p>
                                  </div>
                                </div>


                                <div className="text-center mt-3 mb-3">
                                  <a href="https://qrcode-stt.com/contact-us" target="_blank">
                                    <button
                                      type="button"
                                      className="theme-green-bt lastBtn"
                                    >
                                      Contact us
                                    </button>
                                  </a>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>

                        :
                        <div
                          className={"col-plans p-0 " +
                            (selectitemIndex[0] === i.toString() ? "active" : "") + (' ') +
                            (selectitemIndex[0] === (1 + i).toString() ? "zindex99" : "") + (' ') +
                            (selectitemIndex[0] === (i - 1).toString() ? "zindex99" : "") + (' ') +
                            (selectitemIndex[0] === (2 + i).toString() ? "zindex9" : "") + (' ') +
                            (selectitemIndex[0] === (i - 2).toString() ? "zindex9" : "") + (' ') +
                            (selectitemIndex[0] === (3 + i).toString() ? "zindex1" : "") + (' ') +
                            (selectitemIndex[0] === (i - 3).toString() ? "zindex1" : "")
                          }
                          onClick={() => {
                            onselectitemIndex(i);

                          }}
                        >
                          <div className="rounded card-height">
                            <div className=" ">
                              <p className="mb-0 p-1 header-card d-block mainText text-center ">{item?.packageName}</p>
                            </div>
                            {
                              (isMonthly == true || item?.IsDefault == true) ?
                                <b><h2 className="priceLine text-center"><sapn>{item?.currencyOtherName || ''}{item?.price ? item?.price : ""}/month</sapn> </h2></b>
                                : <b><h2 className="priceLine text-center"><sapn>{item?.currencyOtherName || ''}{item?.price ? item?.price : ""}/annum</sapn> </h2></b>
                            }
                            {/* {
                              (isMonthly == true || item?.IsDefault == true) ?
                                <b><h2 className="priceLine text-center"><p>{item?.currencyOtherName || ''}{item?.price ? item?.price : ""}/month</p> </h2></b>
                                : <b><h2 className="priceLine text-center"><p>{item?.currencyOtherName || ''}{item?.price ? item?.price : ""}/annum</p> </h2></b>
                            } */}

                            <div className="card-body p-0 pt-4">
                              <div className="text-center mt-2  pb-1">
                                {
                                  item?.IsDefault == true ? <></> : <p className="card-small-text text-center text-danger">
                                    Anual plan saves 10%
                                  </p>
                                }

                              </div>

                              <div className="text-center mt-3 mb-3">

                              </div>

                              <div className=" rounded">
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      {" "}
                                      <b>{(item?.articalSavingCount === -1 || item?.articalSavingCount === "-1") ? "Unlimited" : item?.articalSavingCount}</b> &nbsp; Life Tag QR Codes
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      {" "}
                                      <b> {(item?.dataStorageCount === -1 || item?.dataStorageCount === "-1") ? "Unlimited" : bytesToSizeRemaining(item?.dataStorageCount)}</b> &nbsp; Data storage limit
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">

                                      <b> {(item?.dynamicQrCodeCount === -1 || item?.dynamicQrCodeCount === "-1") ? "Unlimited" : item?.dynamicQrCodeCount} </b> &nbsp;Dynamic QR Codes
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b> {(item?.staticQrCodeCount === -1 || item?.staticQrCodeCount === "-1") ? "Unlimited" : item?.staticQrCodeCount} </b> &nbsp; Static QR Codes
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b> {(item?.bulkQrCodeCount === -1 || item?.bulkQrCodeCount === "-1") ? "Unlimited" : item?.bulkQrCodeCount} </b> &nbsp; Bulk QR Codes
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b>{(item?.monthlyScanCount === -1 || item?.monthlyScanCount === "-1") ? "Unlimited" : item?.monthlyScanCount}</b> &nbsp;Monthly scans
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b> {(item?.subAccountCount === -1 || item?.subAccountCount === "-1") ? "Unlimited" : item?.subAccountCount}</b>&nbsp; Users and team accounts
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <p className="help-text-simple">
                                      <b>{(item?.noOfChatUser === -1 || item?.noOfChatUser === "-1") ? "Unlimited" : item?.noOfChatUser}</b>&nbsp; Memorial Messages{" "}
                                    </p>
                                  </div>
                                </div>
                                {
                                  item?.IsDefault == true || item?.packageName == "Lite Tag" ?
                                    <></>
                                    :
                                    <div>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <p className="help-text-simple">
                                          <b></b>&nbsp; Premium Support {" "}
                                        </p>
                                      </div>
                                    </div>
                                }

                                {
                                  item?.IsDefault == true ?
                                    <div className="text-center mt-3 mb-3">
                                      <button
                                        onClick={async (e) => {
                                          loginWithRedirect();
                                          // if (loginid === null || loginid === undefined || loginid === "") {
                                          //   localStorage.setItem("Pricingpage", "true");
                                          //   loginWithRedirect();
                                          // }
                                        }}
                                        type="button"
                                        className="theme-green-bt lastBtn"
                                      >
                                        Signup
                                      </button>
                                    </div> :
                                    <div className="text-center mt-3 mb-3">
                                      <button
                                        onClick={async (e) => {
                                          if (loginid === null || loginid === undefined || loginid === "") {
                                            localStorage.setItem("Pricingpage", "true");
                                            loginWithRedirect();
                                          }
                                          else {
                                            if (rolename === "Admin") {
                                              let checkLogin = localStorage.getItem("loginUserID");
                                              if (checkLogin) {
                                                const checkuserlock = await CheckUserIslock(checkLogin);
                                                if (checkuserlock === false || checkuserlock === false) {
                                                  swal(
                                                    "oops!",
                                                    "Sorry! You can not do any transaction in 1 hour.",
                                                    "warning"
                                                  );
                                                }
                                                else {
                                                  setisPaymentshow(false)
                                                  // setpackagePriceID(item?.priceId);
                                                  setIsRazorAvailable(item?.isRazorPayAvailable ? item?.isRazorPayAvailable : false)
                                                  if (item?.isRazorPayAvailable == true) {
                                                    setisstripePay("Razorpay");
                                                  }
                                                  else {
                                                    setisstripePay('Stripepay')
                                                  }
                                                  setpackagePriceID(item?.uniqueGuid);
                                                  setPaymentDetailsisOpen(true)
                                                  setPackageName(item?.packageName)
                                                  settotalPrice(
                                                    (item?.currencyOtherName ? item?.currencyOtherName : 'N/A') + " " + (item?.price ? item?.price : 0)
                                                  );
                                                  setpackageID(item?._id)
                                                }
                                              }
                                              else {
                                                swal("Only admin user support")
                                              }
                                            }
                                            else{
                                              swal("Only admin user support")
                                            }
                                          }
                                        }}
                                        type="button"
                                        className="theme-green-bt lastBtn"
                                      >
                                        GET STARTED
                                      </button>
                                    </div>
                                }
                              </div>

                            </div>
                          </div>
                        </div>


                    ))
                    : <></>
                  }


                </div>

              </div>
            </div>

          </div>
        </div>

        {/* price */}
        {/*faq*/}
        <div className="faq">

          {/* <div className="widget-container">
{" "}
<h2 className="price-heading-title">
  Have more questions about our plans (Checkout below plans FAQs)
</h2>
<h2 className="elementor-heading-title small-header">Checkout below plans FAQs</h2>
</div> */}

          <div className="container">
            <h2 className="Frequently-Asked-Questions">
              Frequently Asked Questions
            </h2>

          </div>
          <div className="container mb-4">
            <div className="row">
              <div className="col-md-12">
                <div id="accordion">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                        >
                          Can I use STT QR Code generator for free?
                          <i className="fa fa-angle-down icon-show iconFaq"
                            aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                        </button>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      className="panel-collapse collapse "
                      aria-labelledby="headingOne"
                    //   data-parent="#accordion"
                    >
                      <div className="card-body ">
                        Yes, you can use the STT QR Code generator for free by signing up for the Free package, no credit card required. If you like it, you can subscribe to a paid package or contact us for customized options. The Free package is valid for one month.

                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          What payment method do you accept?
                          <i className="fa fa-angle-down icon-show iconFaq"
                            aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseTwo"
                      className="panel-collapse collapse"
                      aria-labelledby="headingTwo"
                    //   data-parent="#accordion"
                    >
                      <div className="card-body">
                        We accept payments via Stripe using credit cards. For customized packages, we also accept bank transfers, wire transfers, or direct debit. Please contact us in advance for these options.

                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          How is my data storage and number of chatting users calculated?
                          <i className="fa fa-angle-down icon-show iconFaq"
                            aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseThree"
                      className="panel-collapse collapse"
                      aria-labelledby="headingThree"
                    //   data-parent="#accordion"
                    >
                      <div className="card-body">
                        Data storage includes all images, files, and videos posted on the STT platform, but not YouTube URL videos. Chatting users include all customers contacting you about any product.

                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingFour">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Can I cancel/ change my plan?
                          <i className="fa fa-angle-down icon-show iconFaq"
                            aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseFour"
                      className="panel-collapse collapse "
                      aria-labelledby="headingFour"
                    //   data-parent="#accordion"
                    >
                      <div className="card-body ">
                        You can cancel your subscription anytime in the settings section, effective at the end of the current period. Upgrades are allowed anytime with a prorated refund. Downgrades are possible only after the current period ends.

                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingFive">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          What happen to my QR Codes and data once I discontinue my subscription?
                          {" "} <i className="fa fa-angle-down icon-show iconFaq"
                            aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseFive"
                      className="panel-collapse collapse"
                      aria-labelledby="headingFive"
                    //   data-parent="#accordion"
                    >
                      <div className="card-body">
                        Your QR Codes and data remain active until your subscription ends. You can resubscribe anytime to access your data again.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingSix">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          Do you provide any discounts to no-profit or educational institution?
                          {" "} <i className="fa fa-angle-down icon-show iconFaq"
                            aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseSix"
                      className="collapse"
                      aria-labelledby="headingSix"
                    //   data-parent="#accordion"
                    >
                      <div className="card-body">
                        Yes, please contact us for additional details.
                        <i className="fa fa-angle-down icon-show iconFaq"
                          aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingSeven">
                      <h5 className="mb-0">
                        <button
                          className="btn btn-dark-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          Do the prices include VAT (value added tax) ?
                          {" "} <i className="fa fa-angle-down icon-show iconFaq"
                            aria-hidden="true"></i><i className="fa fa-angle-up icon-close iconFaq "></i>
                        </button>
                      </h5>
                    </div>
                    <div
                      id="collapseSeven"
                      className="collapse"
                      aria-labelledby="headingSeven"
                    //   data-parent="#accordion"
                    >
                      <div className="card-body">
                        Yes

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>


        </div>
        {/* footer */}
        <footer className="footer-04">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-3 mb-md-0 mb-4 d-flex flex-column align-items-start ">
                {/* <div className="footer-heading text-center">
                  <a href="https://qrcode-stt.com/" className="logo">
                    <img src="../assets/img/sttwordpressweb/folog1.png" />{" "}
                  </a>
                </div> */}
                <a
                  href="#" onClick={(e) => { e.preventDefault(); }}
                  className="footer-email">
                  info@qrcode-stt.com
                </a>
                <ul className="ftco-footer-social">
                  <li className="ftco-animate">
                    <a
                      target="_blank"
                      href="https://www.facebook.com/profile.php?id=61552372797008"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="Facebook"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24"><path fill="currentColor" d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95" /></svg>                    </a>
                  </li>
                  {/* <li className="ftco-animate">
                    <a
                      href="https://www.facebook.com/profile.php?id=61552372797008"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="Twitter"
                    >
                      <span className="ion-logo-twitter"></span>
                    </a>
                  </li> */}



                  <li className="ftco-animate">
                    <a
                      target="_blank"
                      href="https://instagram.com/qrcode.stt?igshid=OGQ5ZDc2ODk2ZA=="
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="Instagram"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24"><path fill="currentColor" d="M12.001 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6m0-2a5 5 0 1 1 0 10a5 5 0 0 1 0-10m6.5-.25a1.25 1.25 0 0 1-2.5 0a1.25 1.25 0 0 1 2.5 0M12.001 4c-2.474 0-2.878.007-4.029.058c-.784.037-1.31.142-1.798.332a2.886 2.886 0 0 0-1.08.703a2.89 2.89 0 0 0-.704 1.08c-.19.49-.295 1.015-.331 1.798C4.007 9.075 4 9.461 4 12c0 2.475.007 2.878.058 4.029c.037.783.142 1.31.331 1.797c.17.435.37.748.702 1.08c.337.336.65.537 1.08.703c.494.191 1.02.297 1.8.333C9.075 19.994 9.461 20 12 20c2.475 0 2.878-.007 4.029-.058c.782-.037 1.308-.142 1.797-.331a2.91 2.91 0 0 0 1.08-.703c.337-.336.538-.649.704-1.08c.19-.492.296-1.018.332-1.8c.052-1.103.058-1.49.058-4.028c0-2.474-.007-2.878-.058-4.029c-.037-.782-.143-1.31-.332-1.798a2.912 2.912 0 0 0-.703-1.08a2.884 2.884 0 0 0-1.08-.704c-.49-.19-1.016-.295-1.798-.331C14.926 4.006 14.54 4 12 4m0-2c2.717 0 3.056.01 4.123.06c1.064.05 1.79.217 2.427.465c.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.047 1.066.06 1.405.06 4.122c0 2.717-.01 3.056-.06 4.122c-.05 1.065-.218 1.79-.465 2.428a4.884 4.884 0 0 1-1.153 1.772a4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465c-1.067.047-1.406.06-4.123.06c-2.717 0-3.056-.01-4.123-.06c-1.064-.05-1.789-.218-2.427-.465a4.89 4.89 0 0 1-1.772-1.153a4.905 4.905 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.012 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122c.05-1.065.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.637-.248 1.362-.415 2.427-.465C8.945 2.013 9.284 2 12.001 2" /></svg>                    </a>
                  </li>
                  <li className="ftco-animate">
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/stt-scan-to-tell/"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="Linkedin"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 20 20"><path fill="currentColor" d="M10 .4C4.698.4.4 4.698.4 10s4.298 9.6 9.6 9.6s9.6-4.298 9.6-9.6S15.302.4 10 .4M7.65 13.979H5.706V7.723H7.65zm-.984-7.024c-.614 0-1.011-.435-1.011-.973c0-.549.409-.971 1.036-.971s1.011.422 1.023.971c0 .538-.396.973-1.048.973m8.084 7.024h-1.944v-3.467c0-.807-.282-1.355-.985-1.355c-.537 0-.856.371-.997.728c-.052.127-.065.307-.065.486v3.607H8.814v-4.26c0-.781-.025-1.434-.051-1.996h1.689l.089.869h.039c.256-.408.883-1.01 1.932-1.01c1.279 0 2.238.857 2.238 2.699z" /></svg>
                    </a>
                  </li>
                </ul>
                <div className="">
                  <div className="col-md-11 download-btn-row mt-3">
                    <a
                      className="elementor-button-link"
                      href="https://qrcode-stt.com/free-trial/"
                    >
                      {" "}
                      Free trial
                    </a>
                    <div className="d-flex">
                      <a
                        className="elementor-storebutton "
                        href="#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6IjEyNjA3IiwidG9nZ2xlIjp0cnVlfQ%3D%3D"
                      >
                        <img src="../assets/img/sttwordpressweb/ios.png" />
                      </a>
                      <a
                        className="elementor-storebutton"
                        href="https://play.google.com/store/apps/details?id=com.scantotellv1.stt"
                      >
                        <img src="../assets/img/sttwordpressweb/google-play.png" />
                      </a>
                      {/* <div className="col-md-12 text-center">
                       
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-md-0 mb-4">
                <h2 className="footer-heading">Company</h2>
                <ul className="list-unstyled">
                  <li>
                    <a
                      href="https://qrcode-stt.com/about-us/"
                      className="footer-link"
                    >
                      About us
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://qrcode-stt.com/why-and-how-does-it-work/"
                      className="footer-link"
                    >
                      Why STT QR Code generator
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://qrcode-stt.com/knowledge-based-blogs-2/"
                      className="footer-link"
                    >
                      Knowledge based blog
                    </a>
                  </li>
                  <li>
                    <a href="https://qrcode-stt.com/demo/" className="footer-link">
                      Schedule a demo
                    </a>
                  </li>
                  <li>
                    <a href="https://qrcode-stt.com/career/" className="footer-link">
                      Career
                    </a>
                  </li>
                  <a
                    href="https://qrcode-stt.com/sitemap/"
                    style={{ fontSize: "20px" }}
                    className="footer-link mt-3"
                  >
                    Sitemap
                  </a>
                  {/* <li>
                    <a
                      href="https://qrcode-stt.com/our-world-wide-offices/"
                      className="footer-link"
                    >
                      Our world wide offices
                    </a>
                  </li> */}
                </ul>
              </div>
              <div className="col-md-6 col-lg-3 mb-md-0 mb-4">
                <h2 className="footer-heading">QR Code Solutions</h2>
                <div className="list-unstyled">
                  <a
                    href="https://qrcode-stt.com/product-qr-code-generator/"
                    className="footer-link"
                  >
                    QR Codes for products
                  </a>
                  <a
                    href="https://qrcode-stt.com/bulk-qr-code/"
                    className="footer-link"
                  >
                    Bulk QR Cod es
                  </a>
                  <a
                    href="https://qrcode-stt.com/end-consumer-communication/"
                    className="footer-link"
                  >
                    End consumer communication
                  </a>
                  <a
                    href="https://qrcode-stt.com/personal-qr-code-2/"
                    className="footer-link"
                  >
                    Personal QR Codes
                  </a>
                  <a
                    href="https://qrcode-stt.com/deep-scanning-analytics/"
                    className="footer-link"
                  >
                    QR Code scanning analytics
                  </a>
                  <a
                    href="https://qrcode-stt.com/pricing/"
                    style={{ fontSize: "20px" }}
                    className="footer-link mt-3"
                  >
                    Pricing
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-md-0 mb-4">
                {/* <a
                  href="https://qrcode-stt.com/contact-us/"
                  style={{ fontSize: "20px" }}
                  className="footer-heading"
                >Contact us</a> */}
                {/* <h2 className="footer-heading">Contact us</h2> */}
                <a
                  href="https://qrcode-stt.com/contact-us/"
                ><h2 className="footer-heading">Contact us</h2></a>
                <div className="list-unstyled">
                  <a
                    href="https://qrcode-stt.com/privacy-policy"
                    className="footer-link"
                  >
                    Privacy policy
                  </a>
                  <a
                    href="https://qrcode-stt.com/terms-of-service/"
                    className="footer-link"
                  >
                    Terms of service
                  </a>
                  <a
                    href="https://qrcode-stt.com/cookies-policy/"
                    className="footer-link"
                  >
                    Cookies policy
                  </a>
                  <a
                    href="https://qrcode-stt.com/impression/"
                    style={{ fontSize: "20px" }}
                    className="footer-link mt-5 pt-5"
                  >
                    Impression
                  </a>
                </div>
              </div>
            </div>

          </div>
          <div className="w-100 footer-bottom-container">
            <div className="container ">
              <div className="row">
                <div className="col-md-12 text-center">
                  <p className="copyright">
                    © QR Code is registered Trademark of Denso Wave incorporated
                  </p>
                  <p className="copyright">
                    © STT-Scan to Tell QR code generator, All rights reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* footer */}
      </div>
      <Modal
        isOpen={PaymentDetailsisOpen}
        className="modal-size"
        onHide={() => togglePaymentDetails()}
      >
        <ModalHeader
          toggle={togglePaymentDetails}
          className="modalheader"
        >
          <h5 className="text-white mb-0">Payment</h5>
        </ModalHeader>
        <ModalBody>
          <>
            <div className="form-group row m-b-10 flex-wrap">
              <label className="col-md-8 col-form-label" htmlFor="autorenewal">
                Your subscribed package
              </label>
              <div className="searchForm col-md-4">
                {PackageName
                  ? PackageName
                  : "N/A"}
              </div>
              <label className="col-md-8 col-form-label" htmlFor="autorenewal">
                Your package
              </label>
              <div className="searchForm col-md-4">
                {isMonthly === false
                  ? "Yearly"
                  : "Monthly"}
              </div>
              <label
                className="col-md-8 col-form-label"
              // htmlFor="autorenewal"
              >
                Package Price
              </label>
              <label
                className="col-md-4 col-form-label"
              >
                {totalPrice ? totalPrice : 0}
              </label>
              <label className="col-md-8 col-form-label">
                Your subscribed package auto renewal
              </label>
              <div className="searchForm col-md-4 mt-2">
                <input
                  type="checkbox"
                  value=""
                  disabled={isPaymentshow}
                  id="autorenewal"
                  checked={autorenewal}
                  onChange={(e) => {
                    setautorenewal(!autorenewal);
                  }}
                />
              </div>

              <label className="col-md-8 col-form-label">
                Payment Type
              </label>
              <div className="searchForm col-md-4 mt-2">
                <div className="row">
                  <div className="col-md-12 col-form-label">
                    <input
                      type="radio"
                      checked={isstripePay === "Stripepay" ? true : false}
                      disabled={isPaymentshow || isRazorAvailable}
                      onChange={() => {
                        if (!isPaymentshow) {
                          setisstripePay('Stripepay')
                        }
                      }}
                    />
                    <label className="mr-2 ml-2">
                    Stripe Pay {"(International)"}
                    </label>
                  </div>
                  <div className="col-md-12 col-form-label">
                    <input
                      type="radio"
                      checked={isstripePay === "Razorpay" ? true : false}
                      disabled={isPaymentshow || !isRazorAvailable}
                      onChange={() => {
                        if (!isPaymentshow && isRazorAvailable) {
                          setisstripePay("Razorpay")
                        }
                      }}
                    />
                    <label className="mr-2 ml-2">
                    Razor Pay {"(Indian, UPI, QR Code, Credit Card, Debit & Others)"}
                    </label>
                  </div>
                </div>

              </div>
            </div>
            <div className="form-group row m-b-10 flex-wrap mt-4">
              <div className="my-2  my-xl-0 ml-md-2">
                {isPaymentshow ? (
                  <>
                    {
                      isstripePay === "Stripepay" ?
                        <button
                          type="button"
                          className="btn  btn-primary m-r-5 shadow-add"

                          onClick={async () => {
                            let checkLogin = localStorage.getItem("loginUserID");
                            if (checkLogin) {
                              const checkuserlock = await CheckUserIslock(checkLogin);
                              if (checkuserlock === false || checkuserlock === false) {
                                swal(
                                  "oops!",
                                  "Sorry! You can not do any transaction in 1 hour.",
                                  "warning"
                                );
                              }
                              else {
                                onSubmit();
                              }
                            }
                          }}
                        >
                          {`Stripe Pay ${totalPrice ? totalPrice : 0}`}
                        </button>
                        : isstripePay === "Razorpay" ? <button
                          type="button"
                          className="btn  btn-primary m-r-5 shadow-add"
                          onClick={async () => {
                            let checkLogin = localStorage.getItem("loginUserID");
                            if (checkLogin) {
                              const checkuserlock = await CheckUserIslock(checkLogin);
                              if (checkuserlock === false || checkuserlock === false) {
                                swal(
                                  "oops!",
                                  "Sorry! You can not do any transaction in 1 hour.",
                                  "warning"
                                );
                              }
                              else {
                                onSubmitRazorpay();
                              }
                            }
                          }}
                        >
                          {`Razor Pay ${totalPrice ? totalPrice : 0}`}
                        </button>
                          : <></>
                    }
                  </>
                ) : (
                  <button
                    type="button"
                    className="btn  btn-primary m-r-5 shadow-add"
                    onClick={async () => {
                      let checkLogin = localStorage.getItem("loginUserID");
                      if (checkLogin) {
                        const checkuserlock = await CheckUserIslock(checkLogin);
                        if (checkuserlock === false || checkuserlock === false) {
                          swal(
                            "oops!",
                            "Sorry! You can not do any transaction in 1 hour.",
                            "warning"
                          );
                        }
                        else {
                          Proceedpackage();
                        }
                      }
                    }}
                  >
                    Proceed
                  </button>
                )}
              </div>
            </div>
          </>
        </ModalBody>
      </Modal>



      <Modal
        isOpen={MobileUserPaymentDetailsisOpen}
        className="modal-dialog-centered"
        onHide={() => togglePaymentDetailsMobileUser()}
      >
        <ModalHeader
          toggle={togglePaymentDetailsMobileUser}
          className="modalheader"
        >
          <h5 className="text-white mb-0">Payment</h5>
        </ModalHeader>
        <ModalBody>
          <>
            <div className="form-group row m-b-10 flex-wrap">
              <label className="col-md-8 col-form-label" htmlFor="autorenewal">
                Your subscribed package
              </label>
              <div className="searchForm col-md-4">
                {PackageName
                  ? PackageName
                  : "N/A"}
              </div>
              <label className="col-md-8 col-form-label" htmlFor="autorenewal">
                Your package
              </label>
              <div className="searchForm col-md-4">
                {isMonthly === false
                  ? "Yearly"
                  : "Monthly"}
              </div>
              <label
                className="col-md-8 col-form-label"
              // htmlFor="autorenewal"
              >
                Package Price
              </label>
              <label
                className="col-md-4 col-form-label"
              // htmlFor="autorenewal"
              >
                {totalPrice ? totalPrice : 0}
              </label>
              <label className="col-md-8 col-form-label">
                Your subscribed package auto renewal
              </label>
              <div className="searchForm col-md-4 mt-2">
                <input
                  type="checkbox"
                  value=""
                  disabled={isPaymentshow}
                  id="autorenewal"
                  checked={autorenewal}
                  onChange={(e) => {
                    setautorenewal(!autorenewal);
                  }}
                />
              </div>
            </div>
            <div className="form-group row m-b-10 flex-wrap mt-4">
              <div className="my-2  my-xl-0 ml-md-2">
                {isPaymentshow ? (
                  <button
                    type="button"
                    className="btn  btn-primary m-r-5 shadow-add"

                    onClick={async () => {
                      let checkLogin = localStorage.getItem("loginUserID");
                      if (checkLogin) {
                        const checkuserlock = await CheckUserIslock(checkLogin);
                        if (checkuserlock === false || checkuserlock === false) {
                          swal(
                            "oops!",
                            "Sorry! You can not do any transaction in 1 hour.",
                            "warning"
                          );
                        }
                        else {
                          onSubmit();
                        }
                      }
                    }}
                  >
                    {/* {"Pay (" + totalPrice + " )"} */}
                    {`Pay ${totalPrice ? totalPrice : 0}`}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn  btn-primary m-r-5 shadow-add"
                    onClick={async () => {
                      let checkLogin = localStorage.getItem("loginUserID");
                      if (checkLogin) {
                        const checkuserlock = await CheckUserIslock(checkLogin);
                        if (checkuserlock === false || checkuserlock === false) {
                          swal(
                            "oops!",
                            "Sorry! You can not do any transaction in 1 hour.",
                            "warning"
                          );
                        }
                        else {
                          Proceedpackage();
                        }
                      }
                    }}
                  >
                    Proceed
                  </button>
                )}
              </div>


            </div>
          </>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={IsuserDetailsisOpen}
        className="modal-dialog-centered"
        onHide={toggleUserDetails}
      >
        <ModalHeader
          toggle={toggleUserDetails}
          className="modalheader"
        >
          <h5 className="text-white mb-0">Mobile Login Email Details</h5>
        </ModalHeader>
        <ModalBody>
          <div className="form-group row m-b-10 flex-wrap">

            <label htmlFor="exampleInputEmail1"> Enter Your Email</label>
            <input
              type="text"
              className="form-control input-design-1"
              placeholder="Enter your mobile login email"
              value={MobileUserEmail}
              onChange={(event) => {
                setMobileUserEmailError("");
                setMobileUserEmail(event.target.value)
              }}
            />
          </div>
          <div className="form-group row m-b-10 flex-wrap mt-4">
            <button
              type="button"
              className="btn  btn-primary m-r-5 shadow-add"
              onClick={async () => {
                if (MobileUserEmail) {
                  let responseuser = await GetFullMobileUserDetailByEmailAddress(MobileUserEmail);
                  if (responseuser?._id) {
                    setPaymentDetailsisOpen(true)
                  }
                  else {
                    swal("Sorry!", "User not not found", "error");
                  }
                }
                else {
                  setMobileUserEmailError("Please Enter Email");
                }
              }}
            >
              Submit
            </button>
            <button
              type="button"
              className="btn btn btn-danger m-r-5 shadow-add"
              onClick={() => {
                setMobileUserEmailError("");
                setMobileUserEmail("");
                setIsuserDetailsisOpen(false);

              }}
            >
              Cancel
            </button>

          </div>

        </ModalBody>

      </Modal>
    </>
  );
};

export default Pricingpage;